module.exports = __webpack_public_path__ + "img/pipeline.838cb97f.svg";